var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-data-table',{attrs:{"items":_vm.documentos,"headers":_vm.headers,"items-per-page":10,"hide-default-footer":""},scopedSlots:_vm._u([{key:"item.link",fn:function({item}){return [_c('v-btn',{attrs:{"small":"","color":"secondary OnSecondary--text","href":item.link,"target":"_blank","download":""}},[_vm._v("Descargar")])]}}])})
}
var staticRenderFns = []

export { render, staticRenderFns }